import React, { PureComponent } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Popup } from 'semantic-ui-react';
import { Map } from 'immutable';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  AdminTargetInTableMenu,
  ReactTableFilterAzSearch,
  ReactTableFilterDatePicker,
  ReactTableFilterDropdown,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  Loading,
  TagItem
} from 'components';
import { Icon, Image, Label } from 'semantic-ui-react';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './AdminTargetList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class AdminTargetList extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isAuth, data, fromNowClass, targetDataByTargetNo, targetOrdering, ...rest } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const { handleChangeFilter, handleChangeDateFilter } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const targetData = targetOrdering.map((targetNo, i) => {
      return targetDataByTargetNo.get(String(targetNo));
    });

    const columns = [
      {
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 45,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          return <AdminTargetInTableMenu isAuth={isAuth} targetInfo={{ ...original }} />;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_3', defaultMessage: '서비스No' }))}
          />
        ),
        accessor: 'serviceNo',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_2', defaultMessage: '서비스명' }))}
          />
        ),
        accessor: 'serviceName',
        sortable: true,
        minWidth: 143,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text')
      },
      {
        Header: <ReactTableHeaderText title="No" />,
        accessor: 'targetNo',
        sortable: true,
        resizable: false,
        width: 72,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center number-text')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_5', defaultMessage: '이름' }))}
          />
        ),
        accessor: 'targetName',
        sortable: true,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center', 'targetStatus'),
        Cell: ({ original }) => {
          const examInfo = original.examInfo;
          const targetNo = original.targetNo;
          const targetName = original.targetName;
          const targetEmail = original.targetEmail;
          const targetPhone = original.targetPhone;
          let examStatus = 0;
          if (!!examInfo) {
            examStatus = 1;
            // 메일 열람
            if (!!examInfo.read) {
              examStatus = 2;
              // 파일 다운
              if (!!examInfo.download) {
                if (examInfo.examType === 4) {
                  examStatus = 4;
                } else {
                  examStatus = 3;
                }
              }
              // 감염
              if (!!examInfo.infection) {
                if (examInfo.examType === 4) {
                  examStatus = 6;
                } else {
                  examStatus = 5;
                }

                // 치료
                if (!!examInfo.cure) {
                  examStatus = 7;
                }
              }
            }
          }
          return (
            <Popup
              trigger={
                <div className={cx('targetInfo-area', 'ellipsis')}>
                  <div
                    className={cx(
                      { 'brand-green': examStatus === 1 },
                      { 'color-orange': examStatus === 2 },
                      { 'color-down': examStatus === 3 },
                      { 'color-down': examStatus === 4 },
                      { 'color-red': examStatus === 5 },
                      { 'color-red': examStatus === 6 },
                      { 'color-cure': examStatus === 7 }
                    )}>
                    <Icon name="user" />
                  </div>
                  <span className={cx('targetName')}>{targetName}</span>
                </div>
              }
              content={
                <div>
                  <div className={cx('targetInfo-area')}>
                    <div className={cx('targetInfo-title')}>
                      {defineMessages(formatMessage({ id: 'TargetItem_8', defaultMessage: '최근 훈련 결과' }))}
                    </div>
                    <div
                      className={cx(
                        'bold',
                        { 'brand-green': examStatus === 1 },
                        { 'color-orange': examStatus === 2 },
                        { 'color-down': examStatus === 3 },
                        { 'color-down': examStatus === 4 },
                        { 'color-red': examStatus === 5 },
                        { 'color-red': examStatus === 6 },
                        { 'color-cure': examStatus === 7 }
                      )}>
                      {examStatus === 0 &&
                        defineMessages(formatMessage({ id: 'TargetItem_9', defaultMessage: '없음' }))}
                      {examStatus === 1 &&
                        defineMessages(formatMessage({ id: 'TargetItem_10', defaultMessage: '양호' }))}
                      {examStatus === 2 &&
                        defineMessages(formatMessage({ id: 'TargetItem_11', defaultMessage: '메일 열람' }))}
                      {examStatus === 3 &&
                        defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      {examStatus === 4 &&
                        defineMessages(formatMessage({ id: 'TargetItem_13', defaultMessage: '피싱 접속' }))}
                      {examStatus === 5 &&
                        defineMessages(formatMessage({ id: 'TargetItem_12', defaultMessage: 'PC 감염' }))}
                      {examStatus === 6 &&
                        defineMessages(formatMessage({ id: 'TargetItem_14', defaultMessage: '정보 유출' }))}
                      {examStatus === 7 &&
                        defineMessages(formatMessage({ id: 'TargetDetail_34', defaultMessage: '치료' }))}
                    </div>
                  </div>
                  <div className={cx('targetInfo-area')}>
                    <div className={cx('targetInfo-title')}>
                      {defineMessages(formatMessage({ id: 'TargetItem_1', defaultMessage: '대상자 번호' }))}
                    </div>
                    <div className={cx('bold')}>{targetNo}</div>
                  </div>
                  <div className={cx('targetInfo-area')}>
                    <div className={cx('targetInfo-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_21', defaultMessage: '이름' }))}
                    </div>
                    <div className={cx('bold')}>{targetName}</div>
                  </div>
                  <div className={cx('targetInfo-area')}>
                    <div className={cx('targetInfo-title')}>
                      {defineMessages(formatMessage({ id: 'TargetDetail_22', defaultMessage: '이메일' }))}
                    </div>
                    <div className={cx('bold')}>{targetEmail}</div>
                  </div>
                  {!!targetPhone && (
                    <div className={cx('targetInfo-area')}>
                      <div className={cx('targetInfo-title')}>
                        {defineMessages(formatMessage({ id: 'TargetItem_2', defaultMessage: '연락처' }))}
                      </div>
                      <div className={cx('bold')}>{targetPhone}</div>
                    </div>
                  )}
                </div>
              }
              size="mini"
            />
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_6', defaultMessage: '이메일' }))}
          />
        ),
        accessor: 'targetEmail',
        id: 'targetEmail',
        sortable: true,
        width: 199,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_7', defaultMessage: '연락처' }))}
          />
        ),
        accessor: 'targetPhone',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          let printValue = <div className={cx('text-align-center')}>-</div>;
          if (original.targetPhone) {
            printValue = original.targetPhone;
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_8', defaultMessage: '소속' }))}
          />
        ),
        accessor: 'targetDivision',
        sortable: true,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          let printValue = <div className={cx('text-align-center')}>-</div>;
          if (original.targetDivision) {
            printValue = original.targetDivision;
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_9', defaultMessage: '직급' }))}
          />
        ),
        accessor: 'targetPosition',
        sortable: true,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          let printValue = <div className={cx('text-align-center')}>-</div>;
          if (original.targetPosition) {
            printValue = original.targetPosition;
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_11', defaultMessage: '태그명' }))}
          />
        ),
        accessor: 'tagList',
        width: 261,
        sortable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'tag-cell'),
        Cell: ({ original }) => {
          const tagList = original.tagList;
          const printValue = <div className={cx('text-align-center')}>-</div>;
          if (tagList) {
            const tagMap = tagList.map((tagData, index) => {
              return (
                <TagItem
                  key={index}
                  tagItem={Map({
                    tagNo: tagData.tagNo,
                    tagName: tagData.tagName,
                    color: tagData.color
                    // tagInitial: detailData.get('tagInitial')
                  })}
                  className={cx('targetItem-tagItem')}
                  size="small"
                />
              );
            });

            return (
              <Popup
                className="max-250"
                trigger={<div className={cx('cell-tag-inner', 'ellipsis')}>{tagMap}</div>}
                content={
                  <div className={cx('target-tagPopup')}>
                    <div className={cx('bold', 'font-size-13')}>
                      <span>{defineMessages(formatMessage({ id: 'TargetItem_5', defaultMessage: '태그' }))}</span>
                      <span className={cx('dark-grey font-size-12 vertical-top')}>
                        {'(' +
                          defineMessages(formatMessage({ id: 'TargetItem_6', defaultMessage: '총' })) +
                          ' ' +
                          tagList.length +
                          defineMessages(formatMessage({ id: 'TargetItem_7', defaultMessage: '개' })) +
                          ')'}
                      </span>
                    </div>
                    <div className={cx('mt-5')}>{tagMap}</div>
                  </div>
                }
                size="mini"
                position="top left"
              />
            );
          } else {
            return printValue;
          }
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_15', defaultMessage: '등록한 계정' }))}
          />
        ),
        accessor: 'userEmail',
        sortable: true,
        minWidth: 199,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'sub-text'),
        Cell: ({ original }) => {
          const createUser = original.createUser;
          let userName = null;
          if (createUser !== 9 && createUser !== 10) {
            userName = original.userName + ' (' + original.userEmail + ')';
          } else {
            userName = original.userEmail;
          }
          return userName;
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminTargetList_1', defaultMessage: '등록일' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        sortable: true,
        resizable: false,
        minWidth: 177,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminTargetList_16', defaultMessage: '마지막 수정일' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('ModifyEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'modifyEpoch',
        sortable: true,
        resizable: false,
        minWidth: 177,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminTargetList_17', defaultMessage: '대상자 메모' }))}
          />
        ),
        accessor: 'targetDetail',
        sortable: false,
        resizable: false,
        minWidth: 177,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text'),
        Cell: ({ original }) => {
          let printValue = <div className={cx('text-align-center')}>-</div>;
          if (original.targetDetail) {
            printValue = original.targetDetail;
          }
          return original.targetDetail ? (
            <Popup
              className="max-250"
              trigger={<div className={cx('cell-tag-inner', 'ellipsis')}>{printValue}</div>}
              content={
                <div className={cx('target-tagPopup')}>
                  <div className={cx('bold', 'font-size-13')}>
                    {/* <span>{defineMessages(formatMessage({ id: 'TargetItem_5', defaultMessage: '태그' }))}</span>
                    <span className={cx('dark-grey font-size-12 vertical-top')}>
                      {'(' +
                        defineMessages(formatMessage({ id: 'TargetItem_6', defaultMessage: '총' })) +
                        ' ' +
                        tagList.length +
                        defineMessages(formatMessage({ id: 'TargetItem_7', defaultMessage: '개' })) +
                        ')'}
                    </span> */}
                  </div>
                  <div className={cx('mt-5')}>{printValue}</div>
                </div>
              }
              size="mini"
              position="top left"
            />
          ) : (
              printValue
            );
        }
      }
    ];

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('react-table-area', fromNowClass.join(' '))}>
        <ReactTableSearch searchObj={searchObj} />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={targetData.toJS()}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'targetNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(formatMessage({ id: 'AdminUserList_13', defaultMessage: '데이터 로딩중...' }))}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                    className: filter.join(' ')
                  }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original && rowInfo.original.isEnabled === 0) {
                return {
                  className: 'delete-item'
                };
              } else {
                return {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

AdminTargetList.propTypes = {};
AdminTargetList.defaultProps = {};

export default injectIntl(AdminTargetList);



// WEBPACK FOOTER //
// ./src/script/components/admin/target/AdminTargetList.js